import React from "react"
import siteUrl from "../../../const/const"
import { cn } from "@/lib/utils"
import { Calendar, ChevronRight } from "lucide-react"

const MONTHS = [
  "yanvar", "fevral", "mart", "aprel", "may", "iyun",
  "iyul", "avqust", "sentyabr", "oktyabr", "noyabr", "dekabr",
]

function formatDate(date: string): string {
  const d = new Date(date)
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${d.getFullYear()}`
}

interface PackageProps {
  pack: {
    name: string
    game: string
    date: string
    organization: { logo: string }
  } | null
  free: boolean
}

const Package: React.FC<PackageProps> = ({ pack, free }) => {
  if (!free || !pack) {
    return (
      <div className={cn(
        "group flex items-center justify-center gap-2",
        "h-[100px] w-full rounded-xl border-2 border-dashed border-blue-200 dark:border-blue-900",
        "bg-blue-50 dark:bg-blue-950 text-blue-500 cursor-pointer dark:text-indigo-300",
 "transition-all duration-200 hover:bg-blue-100 hover:shadow-md"
      )}>
        <span className="text-sm font-semibold">Bütün paketlərə bax</span>
        <ChevronRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
      </div>
    )
  }

  return (
    <div className={cn(
      "relative h-[100px] w-full rounded-xl bg-white dark:border-gray-800 dark:bg-gray-900 border border-gray-100 dark:border-gray-800 p-3",
      "cursor-pointer overflow-hidden",
 "transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
    )}>
      {/* Package name */}
      <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-50 leading-tight line-clamp-2 pr-12 mb-1">
        {pack.name}
      </h4>

      {/* Game type */}
      <p className="text-xs text-blue-500 dark:text-indigo-300 font-medium">{pack.game}</p>

      {/* Date */}
      <div className="absolute bottom-2.5 left-3 flex items-center gap-1 text-gray-400 dark:text-gray-500">
        <Calendar className="w-3 h-3" />
        <span className="text-[10px]">{formatDate(pack.date)}</span>
      </div>

      {/* Org logo */}
      <img
        className="absolute bottom-2.5 right-2.5 h-8 w-8 rounded object-contain bg-gray-50 dark:bg-gray-950 p-0.5"
        alt="organizer"
        src={`${siteUrl}images/logos/${pack.organization.logo}`}
      />
    </div>
  )
}

export default Package
